// extracted by mini-css-extract-plugin
export default {"Lks":"Lks_Lks__fTMJT","LksContainer":"Lks_LksContainer__JBzRd"};